import { createContext, MutableRefObject } from "react";

export const FormContext = createContext<{
	data?: any;
	error?: any;
	setData?: (d: any) => any;
	setError?: (e: any) => any;
	submitRef?: MutableRefObject<HTMLInputElement | null>;
}>({});
